import styled from 'styled-components'
import spinner from '../../../images/main/spinner.svg'

export const Wrapper = styled.div`
  background: #f6f6f6;
  padding: 20px 15px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.2) 0 1px 3px 0;
  width: 320px;
  z-index: 9;
`

export const ThrobberWithSpinner = styled.div`
  height: 150px;
  background-image: url(${spinner});
  background-position: center center;
  background-repeat: no-repeat;
`

export const Table = styled.table`
  margin: 5px 0;
  width: 100%;
  border-bottom: 1px solid #d1d1d1;
  border-collapse: collapse;
  border-spacing: 0;
  background-color: white;
  background-color: transparent;
  border-bottom: none;
`

export const Th = styled.th`
  font-family: 'PT Sans Caption', sans-serif;
  font-size: 12px;
  ${({ cursor }) => `cursor: ${cursor};`};
`

export const Tr = styled.tr`
  border-bottom: 1px solid #d1d1d1;
  height: 30px;
  &:last-of-type {
    border-bottom: none;
  }
`

export const Td = styled.td`
  font-weight: bold;
  text-align: center;
  cursor: default;
`

export const TargetMailRetargetingAndMicroLocationTd = styled(Td)`
  font-weight: normal;
  font-size: 14px;
`

export const Text = styled.div`
  font-family: 'PT Sans Caption', sans-serif;
  font-size: 11px;
  color: #000;
  line-height: 16px;
  padding-bottom: 6px;

  a {
    color: #229dcb;
    text-decoration: none;
    border-bottom: 1px solid rgba(34, 157, 203, 0.5);

    &:hover {
      color: #d80000;
      border-bottom-color: rgba(216, 0, 0, 0.5);
    }
  }
`

export const RetargetingNote = styled.div`
  margin-top: 15px;
`

export const Message = styled.div`
  font-family: 'PT Sans Caption', sans-serif;
  margin-bottom: 5px;
  font-size: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }
`
